import { type Static, Type } from "@sinclair/typebox"
import {
  type ArtworkAssetRecord,
  ArtworkAssetRecordSchema,
  type CardArtwork,
} from "../schemas"

export const ARTWORK_ASSET_STORAGE_KEY = "craft-force.artwork-assets"
export const ARTWORK_ASSET_STORAGE_VERSION = 1

export const ArtworkAssetStoreSchema = Type.Array(ArtworkAssetRecordSchema)
export type ArtworkAssetStore = Static<typeof ArtworkAssetStoreSchema>

export const EMPTY_ARTWORK_ASSET_STORE: ArtworkAssetStore = []
let runtimeArtworkAssetStore: ArtworkAssetStore = EMPTY_ARTWORK_ASSET_STORE

export function getRuntimeArtworkAssets(): ArtworkAssetStore {
  return runtimeArtworkAssetStore
}

export function upsertArtworkAssets(
  assets: readonly ArtworkAssetRecord[],
  nextAssets: readonly ArtworkAssetRecord[],
): ArtworkAssetStore {
  const byId = new Map(assets.map((asset) => [asset.assetId, asset]))
  for (const asset of nextAssets) {
    byId.set(asset.assetId, asset)
  }
  const nextStore = [...byId.values()].sort((left, right) =>
    left.createdAt.localeCompare(right.createdAt),
  )
  runtimeArtworkAssetStore = nextStore
  return nextStore
}

export function findArtworkAssetUrl(
  artwork: CardArtwork | undefined,
  assets: readonly ArtworkAssetRecord[],
  kind: "card_art" | "thumb",
): string | null {
  if (!artwork) return null
  const variant = artwork.variants.find((entry) => entry.kind === kind)
  if (!variant) return null
  return (
    assets.find((asset) => asset.assetId === variant.assetId)?.dataUrl ??
    runtimeArtworkAssetStore.find((asset) => asset.assetId === variant.assetId)
      ?.dataUrl ??
    null
  )
}

export function collectArtworkAssets(
  artwork: CardArtwork | undefined,
  assets: readonly ArtworkAssetRecord[],
): ArtworkAssetRecord[] {
  if (!artwork) return []

  const assetIds = new Set(artwork.variants.map((variant) => variant.assetId))
  return assets.filter((asset) => assetIds.has(asset.assetId))
}
